import { render, staticRenderFns } from "./NewExtensionModal.vue?vue&type=template&id=2032da68&scoped=true&"
import script from "./NewExtensionModal.vue?vue&type=script&lang=js&"
export * from "./NewExtensionModal.vue?vue&type=script&lang=js&"
import style0 from "./NewExtensionModal.vue?vue&type=style&index=0&id=2032da68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2032da68",
  null
  
)

export default component.exports